import { EventDTO } from "@hypexone/uicore";

// One definition of Live / Virtual / Premium, shared by the list filters, the
// counts on those filter buttons and the live badges in the sub-header, so
// the numbers always match the rows the user sees.

export const isVirtualEvent = (event: EventDTO) =>
  !!event?.virtualEvent || event?.catId === "SR VIRTUAL";

export const isLiveEvent = (event: EventDTO) =>
  event?.status?.toLowerCase() === "in_play" && !isVirtualEvent(event);

// Premium = the rows wearing the "P" (premium markets) icon, plus SportRadar
// events, which are premium-only.
export const isPremiumEvent = (event: EventDTO) =>
  !isVirtualEvent(event) &&
  (!!event?.enablePremium || event?.providerName === "SportRadar");

export type EventFilterFlags = {
  isLive?: boolean;
  isVirtual?: boolean;
  isPremium?: boolean;
};

export const filterEvents = (
  events: EventDTO[] = [],
  { isLive, isVirtual, isPremium }: EventFilterFlags
) => {
  if (isLive) return events.filter(isLiveEvent);
  if (isVirtual) return events.filter(isVirtualEvent);
  if (isPremium) return events.filter(isPremiumEvent);
  return events;
};

export type EventFilterCounts = {
  live: number;
  virtual: number;
  premium: number;
};

export const countEventFilters = (
  events: EventDTO[] = []
): EventFilterCounts => ({
  live: events.filter(isLiveEvent).length,
  virtual: events.filter(isVirtualEvent).length,
  premium: events.filter(isPremiumEvent).length,
});
